import {styled} from 'styled-components';
import {Table, TableColumnsType} from 'antd';
import {FC} from 'react';
import {createReportColumns} from './ui/createReportColumns';
import {
    IAverageCheckByDays,
    ICountChecksByDays,
    IRevenueByDays,
    reportsSelect,
} from '../../../../entities/reports';
import {useSelector} from 'react-redux';
import {isNotEmptyArray} from '../../../../utils/functions';
import {flexMixin, textMixin} from '../../../../styles/mixins';
import {colors} from '../../../../styles';
import {PuffLoader} from 'react-spinners';
import {cssOverride} from '../../../../utils/const';
import {DiffRevenueInfo} from './ui/DiffRevenueInfo';

const TableCountChecksByDays: FC = () => {
    const {countChecksByDay, loading} = useSelector(reportsSelect);
    const columns: TableColumnsType<
        IRevenueByDays | ICountChecksByDays | IAverageCheckByDays
    > = createReportColumns({
        title: 'Кол-во чеков за период',
        columns: countChecksByDay?.columns,
    });

    if (!isNotEmptyArray(countChecksByDay?.table)) {
        return <PuffLoader color={colors.loader} cssOverride={cssOverride} />;
    }

    const summary = () => {
        const totals: ICountChecksByDays | undefined = countChecksByDay?.totals;

        if (!totals) {
            return null;
        }

        return (
            <Table.Summary.Row>
                <Table.Summary.Cell index={0}>
                    <strong>Итого</strong>
                </Table.Summary.Cell>

                <Table.Summary.Cell key="Кол-во чеков за период" index={1}>
                    <StyledSum>
                        {totals['Кол-во чеков за период']
                            ? `${totals['Кол-во чеков за период']} шт`
                            : 0}
                    </StyledSum>
                </Table.Summary.Cell>
                <Table.Summary.Cell key="За предыдущий период" index={2}>
                    <StyledSum>
                        {totals['За предыдущий период']
                            ? `${totals['За предыдущий период']} шт`
                            : 0}
                    </StyledSum>
                </Table.Summary.Cell>
                <Table.Summary.Cell key="Динамика" index={3}>
                    <DiffWrapper>
                        <DiffRevenueInfo diff={totals['Динамика']} />
                    </DiffWrapper>
                </Table.Summary.Cell>
            </Table.Summary.Row>
        );
    };

    return (
        <StyledTable>
            <Table
                pagination={false}
                scroll={{x: 700}}
                dataSource={countChecksByDay?.table}
                loading={loading === 'loading'}
                columns={columns}
                summary={summary}
                size="small"
            />
        </StyledTable>
    );
};

export default TableCountChecksByDays;

const StyledTable = styled.div`
    .ant-table-thead > tr > th {
        background-color: ${colors.tableHeadBg};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 600,
        })};
        line-height: 16.8px;
        text-align: left;
        height: 45px;
        padding-right: 1.1em !important;
    }

    .ant-table-footer {
        background-color: ${colors.tableHeadBg};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 600,
        })};
        line-height: 16.8px;
        text-align: left;
    }

    table > tbody > tr > td {
        background-color: ${colors.cleanWhite};
        border: 1px solid #efefef;
        color: ${colors.grey};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 16.8px;
        text-align: left;
        height: 30px;
    }

    .ant-table-summary {
        background-color: ${colors.tableHeadBg};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 600,
        })};
        line-height: 16.8px;
        text-align: left;
        height: 45px;
        tr > td:first-child {
            border-bottom-left-radius: 8px;
        }

        tr > td:last-child {
            border-bottom-right-radius: 8px;
        }
    }
    .ant-table-summary .ant-table-cell {
        padding-top: 4px !important;
        padding-bottom: 4px !important;
    }
`;
const StyledSum = styled.div`
    text-align: right;
    padding-right: 0.5em;
`;
const DiffWrapper = styled.div`
    width: 100%;
    ${flexMixin('row', 'flex-end', 'center')};
    padding-right: 0.5em;
`;
